module.exports = "<div>\r\n    <measurements ng-if=\"source && showMeasurements\" is-kpi=\"true\" source=\"source\"></measurements>\r\n</div>"